<template>

    <ui-view class="view-growers-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle" icon="fa-building">
            <ui-button
                v-if="growerId"
                color="negative"
                icon="magicon-trash"
                @click="deleteGrower">Verwijderen</ui-button>
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>

            <ui-button
                color="medium"
                type="bordered"
                @click="$router.go(-1)"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-input
                title="E-mail adres"
                name="email"
                rules="required|email"
                v-model="pendingGrower.email"/>

            <ui-form-input
                title="Naam"
                name="name"
                rules="required"
                v-model="pendingGrower.name"/>

            <ui-form-input
                title="Adres"
                name="address"
                rules="required"
                v-model="pendingGrower.address"/>

            <ui-form-input
                title="Postcode"
                name="postcode"
                rules="required"
                v-model="pendingGrower.postcode"/>

            <ui-form-input
                title="Telefoon nr."
                name="phoneNumber"
                rules="required"
                v-model="pendingGrower.phoneNumber"/>

            <ui-form-radio
                v-if="isAdmin"
                title="Water inzichten toegankelijk"
                name="waterInsightsAccessible"
                :options="waterInsightsAccessibleOptions"
                rules="required"
                v-model="waterInsightsAccessibleValue"/>

            <ui-form-radio
                v-if="isAdmin"
                title="Leveren aan andere kwekers"
                name="shared"
                :options="waterInsightsAccessibleOptions"
                rules="required"
                v-model="sharedValue"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindGrowerQuery from 'gql/queries/GrowerForm/FindGrower.gql';

import GrowerMutations from 'app/mutations/GrowerMutations';

@Component({

    name: 'GrowerForm',
    apollo: {
        grower: createQuery(FindGrowerQuery, {

            skip() {

                return !this.growerId;
            },

            variables() {

                return {
                    id: this.growerId
                };
            },

            response(data) {

                this.pendingGrower = {
                    ...pick(data, Object.keys(this.pendingGrower)),
                    waterInsightsAccessible: Number(data.waterInsightsAccessible),
                    shared: Number(data.shared)
                };
            }
        })
    }
})
export default class GrowerForm extends Vue {

    loading = 0;
    submitting = false;

    pendingGrower = {
        name: null,
        address: null,
        phoneNumber: null,
        postcode: null,
        email: null,
        waterInsightsAccessible: 0,
        shared: 0
    };

    breadcrumb(){

        return [{
            title: 'Mosselkwekers',
            route: {
                name: 'growers'
            }
        }, this.pageTitle];
    }

    async submit() {

        this.submitting = true;

        let input = {
            ...clone(this.pendingGrower),
            waterInsightsAccessible: !!this.pendingGrower.waterInsightsAccessible,
            shared: !!this.pendingGrower.shared
        };

        try {

            if(this.growerId) {

                input.id = this.growerId;

                await GrowerMutations.update(input);

                this.logger.info('Grower updated');
                this.$toast.success('De mosselkweker is aangepast');
            }
            else {

                await GrowerMutations.create(input);

                this.logger.info('Grower created');
                this.$toast.success('De mosselkweker is aangemaakt');
            }

            this.$router.replace({
                name: 'growers'
            });
        }
        catch(e) {

            this.logger.error('Error creating/updating grower', e);
            this.$toast.error('De mosselkweker kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    async deleteGrower() {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je deze mosselkweker wilt verwijderen?');
        if(!result) {
            return;
        }

        const id = this.growerId;
        try {

            await GrowerMutations.delete(id);

            this.$toast.success('De mosselkweker is succesvol verwijderd');
            this.$router.replace({ name: 'growers' });
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting grower ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van de mosselkweker');
        }

        this.$overlay.close(overlay);
    }

    get pageTitle(){

        return this.growerId ? this.$safe('grower.name') : 'Mosselkweker aanmaken';
    }

    get growerId() {

        return this.$route.params.id;
    }

    get waterInsightsAccessibleOptions(){

        return [
            {
                label: 'Ja',
                value: 1
            },
            {
                label: 'Nee',
                value: 0
            }
        ];
    }

    get waterInsightsAccessibleValue(){

        return this.pendingGrower.waterInsightsAccessible ? 1 : 0;
    }

    set waterInsightsAccessibleValue(value){

        this.pendingGrower.waterInsightsAccessible = Number(value);
    }

    get sharedValue(){

        return this.pendingGrower.shared ? 1 : 0;
    }

    set sharedValue(value){

        this.pendingGrower.shared = Number(value);
    }
}

</script>